import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'
// import extractApiData from 'Helpers/extractApiData'

const endpoints = (baseURL => {
  return {
    isSmsAliasAuthorized: alias =>
      `${baseURL}/api/smsaliasname/${alias}/authorized`,
    getListOfSmsAlias: params =>
      `${baseURL}/api/smsalias?${encodeParams(params)}`
  }
})(process.env.BESMSALIAS_URL)

export const beSmsAliasIsSmsAliasAuthorized = alias => {
  const url = endpoints.isSmsAliasAuthorized(alias)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(res => res.data)
}

export const beSmsAliasGetListOfSmsAlias = params => {
  const url = endpoints.getListOfSmsAlias(params)

  return apiWrapper({
    method: 'get',
    url: url
  }).then(res => res.data)
}
